<p>
  legalization works!
</p>